import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { CategorieDocumentDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-categorie-document',
  templateUrl: './categorie-document.component.html',
  styleUrls: ['./categorie-document.component.css']
})
export class CategorieDocumentComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.categoriesDocument$) categoriesDocument$: Observable<CategorieDocumentDto[]>;

  @Input() public categorieDocumentId: number;

  CategorieDocumentInComponent: CategorieDocumentDto;

  cd: Subscription;

  constructor() {}

  ngOnInit() {
    this.cd = this.categoriesDocument$.subscribe(res => {
      if (res != null) {
        let categorie = res.filter(c => c.Id == this.categorieDocumentId);
        this.CategorieDocumentInComponent = categorie.length == 1 ? categorie[0] : { Identifiant: null };
      }
    });
  }

  ngOnDestroy() {
    this.cd?.unsubscribe();
  }
}
